import { LoginForm } from "../features/auth/components/forms/LoginForm";
import { Logo } from "../shared/components/Logo";
import { ThemeToggle } from "../shared/components/ThemeToggle";

export default function LoginPage() {
    return (
        <div className="min-h-dvh bg-background text-foreground flex flex-col items-center justify-center px-4 py-10">
            {/* Theme toggle — pinned top-right, reuses the in-app store/mechanism */}
            <div className="absolute top-4 right-4">
                <ThemeToggle />
            </div>

            <div className="w-full max-w-md flex flex-col items-center">
                {/* Prominent brand mark */}
                <Logo className="h-9 w-auto mb-8" />

                {/* Auth card */}
                <div className="w-full rounded-2xl border border-border bg-card text-card-foreground shadow-sm px-6 py-8 sm:px-8">
                    <LoginForm />
                </div>

                <p className="mt-6 text-xs text-muted-foreground text-center">
                    The Collective Synergy &middot; Admin
                </p>
            </div>
        </div>
    );
}
